import { BaseService, BaseServiceOptions } from '../../api/services/base-service';
import { AddFeedbackRequest, Feedback } from './feedback.service.interfaces';

export class FeedbackService extends BaseService {
  private feedbackApiUrl: string;

  constructor(opts: BaseServiceOptions) {
    super(opts);
    this.feedbackApiUrl = `${this.apiUrl}/users/v1/end-user/feedbacks`;
  }

  addFeedback(req: AddFeedbackRequest) {
    return this.post<Feedback, AddFeedbackRequest>(this.feedbackApiUrl, req);
  }
}
